import { createRoute } from "@tanstack/solid-router";
import { adminRoute } from "./admin";
import { FlagsManager } from "@/features/admin/components/flags-manager";
import { PageContainer } from "@/components/ui/page-container";

function AdminFlagsPage() {
  return (
    <PageContainer maxWidth="4xl">
      <FlagsManager />
    </PageContainer>
  );
}

export const adminFlagsRoute = createRoute({
  getParentRoute: () => adminRoute,
  path: "/flags",
  component: AdminFlagsPage,
});
